export const LocationIcon = () => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.916504 7.33637C0.916504 3.50315 4.11974 0.404907 7.99438 0.404907C11.8799 0.404907 15.0832 3.50315 15.0832 7.33637C15.0832 9.26798 14.3807 11.0613 13.2244 12.5812C11.9488 14.2578 10.3766 15.7186 8.60696 16.8653C8.20193 17.1303 7.8364 17.1503 7.39188 16.8653C5.61212 15.7186 4.03991 14.2578 2.77525 12.5812C1.61816 11.0613 0.916504 9.26798 0.916504 7.33637ZM5.66169 7.5522C5.66169 8.83633 6.70955 9.8463 7.99438 9.8463C9.28004 9.8463 10.338 8.83633 10.338 7.5522C10.338 6.27807 9.28004 5.21893 7.99438 5.21893C6.70955 5.21893 5.66169 6.27807 5.66169 7.5522Z"
      fill="white"
    />
  </svg>
);

export const PhoneIcon = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.19295 8.5486C11.5172 11.8719 12.2713 8.02721 14.3879 10.1423C16.4284 12.1822 17.6012 12.591 15.0159 15.1756C14.692 15.4358 12.6345 18.5668 5.40367 11.338C-1.82806 4.10828 1.30116 2.04865 1.56148 1.72491C4.15306 -0.866847 4.55472 0.312767 6.59525 2.35272C8.71181 4.46869 4.86872 5.22529 8.19295 8.5486Z"
      fill="white"
    />
  </svg>
);

export const MailIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.02563 0.606297C2.75518 1.1094 0.965203 2.85481 0.404657 5.11224C-0.0235573 6.83674 -0.0235576 8.63983 0.404657 10.3643C0.965203 12.6218 2.75517 14.3672 5.02563 14.8703L5.40385 14.9541C7.114 15.333 8.88633 15.333 10.5965 14.9541L10.9747 14.8703C13.2452 14.3672 15.0351 12.6218 15.5957 10.3643C16.0239 8.63982 16.0239 6.83674 15.5957 5.11224C15.0351 2.85481 13.2452 1.1094 10.9747 0.606297L10.5965 0.522488C8.88633 0.143546 7.114 0.143545 5.40385 0.522488L5.02563 0.606297ZM5.11238 5.91588C4.86527 5.73934 4.52187 5.79658 4.34537 6.04374C4.16886 6.2909 4.2261 6.63438 4.4732 6.81092L6.6153 8.34133C7.44374 8.9332 8.55663 8.9332 9.38506 8.34133L11.5272 6.81092C11.7743 6.63438 11.8315 6.2909 11.655 6.04374C11.4785 5.79658 11.1351 5.73934 10.888 5.91588L8.74589 7.44629C8.29981 7.76499 7.70056 7.76499 7.25448 7.44629L5.11238 5.91588Z"
      fill="white"
    />
  </svg>
);

export const WebsiteIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.45726 7.98827H11.5434C11.3443 5.64277 10.4594 3.40762 9.00033 1.56202C7.54131 3.40762 6.65639 5.64277 6.45726 7.98827ZM11.5434 9.48827H6.45728C6.65645 11.8337 7.54136 14.0688 9.00033 15.9143C10.4593 14.0688 11.3442 11.8337 11.5434 9.48827ZM4.95246 7.98827C5.16013 5.23436 6.20787 2.60979 7.95347 0.470093C4.0897 0.954319 1.0485 4.08381 0.700204 7.98827H4.95246ZM10.0472 0.470118C13.9109 0.954428 16.952 4.08388 17.3003 7.98827H13.0482C12.8405 5.23437 11.7928 2.60981 10.0472 0.470118ZM4.95248 9.48827H0.700195C1.04846 13.3929 4.08981 16.5225 7.95375 17.0066C6.20802 14.8669 5.16019 12.2422 4.95248 9.48827ZM10.0469 17.0065C11.7926 14.8668 12.8405 12.2422 13.0482 9.48827H17.3003C16.952 13.3928 13.9108 16.5224 10.0469 17.0065Z"
      fill="white"
    />
  </svg>
);

export const YoutubeIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.802 12.602C26.802 12.0808 26.7152 11.4727 26.7152 10.7778C26.6283 10.0828 26.5414 9.38787 26.4545 8.77979C26.2808 8.08485 26.0202 7.56364 25.499 7.1293C25.0646 6.69495 24.4566 6.43434 23.8485 6.34747C21.8505 6.08686 18.897 6 14.901 6C10.9051 6 7.86464 6.08686 5.95353 6.34747C5.34545 6.43434 4.73737 6.69495 4.30303 7.1293C3.86869 7.56364 3.52121 8.08485 3.34747 8.77979C3.17373 9.38787 3.08687 9.99596 3.08687 10.7778C3.00001 11.4727 3 12.0808 3 12.602C3 13.1232 3 13.7313 3 14.6C3 15.4687 3 16.1636 3 16.598C3 17.1192 3.08687 17.7273 3.08687 18.4222C3.17374 19.1172 3.2606 19.8121 3.34747 20.4202C3.52121 21.1151 3.78182 21.6364 4.30303 22.0707C4.73737 22.505 5.34545 22.7656 5.95353 22.8525C7.95151 23.1131 10.9051 23.2 14.901 23.2C18.897 23.2 21.9374 23.1131 23.8485 22.8525C24.4566 22.7656 25.0646 22.505 25.499 22.0707C25.9333 21.6364 26.2808 21.1151 26.4545 20.4202C26.6283 19.8121 26.7152 19.204 26.7152 18.4222C26.802 17.7273 26.802 17.1192 26.802 16.598C26.802 16.0768 26.802 15.4687 26.802 14.6C26.802 13.7313 26.802 13.0364 26.802 12.602ZM19.505 15.2949L12.6424 19.5515C12.5556 19.6384 12.3818 19.7253 12.2081 19.7253C12.0343 19.7253 11.9475 19.7252 11.7737 19.6384C11.5131 19.4646 11.3394 19.204 11.3394 18.8566V10.2566C11.3394 9.90908 11.5131 9.64848 11.7737 9.47475C12.0343 9.30101 12.3818 9.30101 12.6424 9.47475L19.505 13.7313C19.7657 13.905 19.9394 14.1657 19.9394 14.4263C19.9394 14.6869 19.7657 15.1212 19.505 15.2949Z"
      fill="white"
    />
  </svg>
);

export const FacebookIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.75 5H6.25C4.98438 5 4 6.03125 4 7.25V23.75C4 25.0156 4.98438 26 6.25 26H12.6719V18.875H9.71875V15.5H12.6719V12.9688C12.6719 10.0625 14.4062 8.42188 17.0312 8.42188C18.3438 8.42188 19.6562 8.65625 19.6562 8.65625V11.5156H18.2031C16.75 11.5156 16.2812 12.4062 16.2812 13.3438V15.5H19.5156L19 18.875H16.2812V26H22.75C23.9688 26 25 25.0156 25 23.75V7.25C25 6.03125 23.9688 5 22.75 5Z"
      fill="white"
    />
  </svg>
);
